"use client";
import useExtensions from '@/hooks/useExtensions';
import { Box } from '@mui/material';
import { RichTextReadOnly } from 'mui-tiptap';
import React, { memo } from 'react'

interface contentProps {
  content: any;
  className?: string;
  slug?: string;
  isHtml?: boolean;
  locale?: string;
}

function isHtmlString(value: any) {
  return typeof value === "string" && /^\s*<([a-z]+|!doctype)/i.test(value);
}

const Content = ({ content, className, isHtml, slug, locale }: contentProps) => {
  const extensions = useExtensions();
  // const pathName = usePathname();
  // const didReplaceRef = useRef<boolean>(false);
  // useEffect(() => {
  //   if (!slug) return;
  //   if (!isHtml) return;
  //   const target = `/${locale}/${slug}`;
  //   if (didReplaceRef.current) return;
  //   if (pathName === target) {
  //     didReplaceRef.current = true;
  //     return;
  //   }
  //   window.history.replaceState(null, "", target);
  //   didReplaceRef.current = true;
  // }, [locale, slug, pathName]);

  if (isHtmlString(content)) {
    return (
      <Box className={`markdown-content ${className || ""}`} dangerouslySetInnerHTML={{ __html: content }} />
    );
  }
  return (
    <Box className={`markdown-content ${className}`}>
      <RichTextReadOnly
        immediatelyRender={true}
        injectCSS={true}
        content={content ?? ""}
        extensions={extensions}
      />
    </Box>
  )
}

export default memo(Content)